import { Gift, Shirt, Tag } from 'lucide-react'

import { rewardLabel } from '../lib/pass-ui'
import type { PassRewardTierItem } from '../types/pass'

import { cn } from '@/shared/lib/utils'

interface RewardItemChipProps {
  item: PassRewardTierItem
  className?: string
}

function RewardIcon({ item }: { item: PassRewardTierItem }) {
  if (item.kind === 'coins') {
    return <img src="/icons/coin.svg" alt="" className="size-5 shrink-0" />
  }
  if (item.kind === 'points') {
    return <img src="/icons/star.svg" alt="" className="size-5 shrink-0" />
  }
  if (item.kind === 'reward_item') {
    return <Gift className="size-5 shrink-0 text-[#7300E6]" />
  }
  if (item.kind === 'cosmetic') {
    return <Shirt className="size-5 shrink-0 text-[#7300E6]" />
  }
  return <Tag className="size-5 shrink-0 text-[#7300E6]" />
}

export function RewardItemChip({ item, className }: RewardItemChipProps) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 text-sm font-semibold text-[#434368]', className)}>
      <RewardIcon item={item} />
      {rewardLabel(item)}
    </span>
  )
}
